import { getServiceWorkerRegistrations } from './service-worker-helpers.js';

// unregister all service workers
if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        try {
            const registrations = await getServiceWorkerRegistrations();
            if (registrations && Array.isArray(registrations) && registrations.length > 0) {
                registrations.forEach(registration => {
                    registration.unregister();
                    console.log('Service Worker unregistered:', registration.scope);
                });
            } else {
                console.log('Service Worker not registered.');
            }
        } catch (error) {
            console.error('Service Worker deregistration failed:', error);
        }
    });
}
